import axios from 'axios';
import { safeDashboardReturn } from '../lib/authReturn';

const api = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL || 'http://localhost:5000/api',
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(config => {
  const workspace = sessionStorage.getItem('activeWorkspaceId');
  if (workspace) config.headers.set('X-Workspace-Id', workspace);
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 403 && error.response?.data?.code === 'workspace_access_revoked') {
      sessionStorage.removeItem('activeWorkspaceId');
      window.location.href = '/dashboard/agency';
    }
    if (error.response?.status === 401) {
      localStorage.removeItem('tenantId');
      sessionStorage.removeItem('activeWorkspaceId');
      
      // Do not violently reload the page if we are already trying to login
      if (error.config?.url !== '/auth/login' && window.location.pathname !== '/login') {
        const returnTo = safeDashboardReturn(window.location.pathname + window.location.search);
        window.location.href = returnTo ? `/login?returnTo=${encodeURIComponent(returnTo)}` : '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
